export enum WorkspacesApiTag {
  participants = "participants",
  workspace = "workspace",
}
